/**
 * D17: paint whatever sides the engine returned. Empty only when both null.
 * Duplicated from widget flows (no shared package).
 */
export type TranslateFundingLimit = (
  key: "payment.minMax" | "payment.minOnly" | "payment.maxOnly",
  options: { min?: string; max?: string }
) => string;

export function formatFundingLimitSubtitle(
  t: TranslateFundingLimit,
  minAmount: number | null | undefined,
  maxAmount: number | null | undefined,
  formatLimit: (value: number) => string
): string {
  const hasMin = minAmount != null;
  const hasMax = maxAmount != null;
  if (hasMin && hasMax) {
    return t("payment.minMax", {
      min: formatLimit(minAmount),
      max: formatLimit(maxAmount),
    });
  }
  if (hasMin) {
    return t("payment.minOnly", { min: formatLimit(minAmount) });
  }
  if (hasMax) {
    return t("payment.maxOnly", { max: formatLimit(maxAmount) });
  }
  return "";
}
